import React, { useState } from 'react';

import { FormattedMessage } from 'react-intl';

import { featureFlags } from '@modules/featureFlags/utils/featureFlags';
import { Card, T, Tabs } from '@shared/components';

import styles from './PermissionsManagerPage.less';
import { UnitInfo } from './UnitInfo/UnitInfo';
import { Assignees } from './assigneesTab/Assignees';
import { TabName } from './constants';
import { PermissionsTab } from './permissionsTab/PermissionsTab';
import { PermissionsViewPanel } from './permissionsTab/components/PermissionViewPanel/PermissionsViewPanel';

const { TabPane } = Tabs;

export const PermissionsManagerPage = () => {
  const [activeTab, setActiveTab] = useState(TabName.ROLES);

  const onChangeTab = (tab: string) => {
    setActiveTab(tab as TabName);
  };

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <T size="1" colored>
          <FormattedMessage id="permissionManager.title" />
        </T>
      </div>
      <UnitInfo />
      <Card margin noPadding shadow className={styles.tabCard}>
        <Tabs
          size="small"
          activeKey={activeTab}
          onChange={onChangeTab}
          className={styles.tabs}
        >
          <TabPane
            tab={
              <FormattedMessage id="permissionManager.tabTitle.rolesPermissions" />
            }
            key={TabName.ROLES}
          >
            <div>
              <PermissionsTab />
            </div>
          </TabPane>
          <TabPane
            tab={<FormattedMessage id="permissionManager.tabTitle.assignees" />}
            key={TabName.ASSIGNEES}
          >
            <div>
              <Assignees />
            </div>
          </TabPane>
          {featureFlags.getFlag('SBL_6477_PERMISSION_VIEWER') && (
            <TabPane
              tab={<FormattedMessage id="permissionManager.tabTitle.view" />}
              key={TabName.VIEW}
            >
              <div>
                <PermissionsViewPanel />
              </div>
            </TabPane>
          )}
        </Tabs>
      </Card>
    </div>
  );
};
